import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const featuredArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-16">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-4">
              精选文章
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              最新资讯与洞见
            </h2>
            <p className="mt-2 text-foreground-500 text-sm">
              了解 aiye 最新动态与技术分享
            </p>
          </div>
          <Link
            to="/article/aiye-2025-product-vision"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span className="px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                    {article.category}
                  </span>
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}